module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="form-horizontal top-margined">\n    <div>\n        ';
 if (forSignup) { 
__p+='\n        <div class="form-group">\n            <label class="col-xs-9 col-md-3 control-label" for="email">Email:</label>\n            <div class="col-xs-9 col-md-9">\n                <input class="form-control" type="text" id="email" placeholder="Email" value="'+
((__t=( email ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n        ';
 } 
__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="id-npi">NPI</label>\n            <div class="col-sm-7 col-md-7">\n                <input class="form-control" type="text" id="id-npi" placeholder="Type or paste NPI" value="'+
((__t=( object.npi ))==null?'':_.escape(__t))+
'">\n            </div>\n            <div class="col-sm-2 col-md-2">\n                <label id="progress"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>\n                    Request...</label>\n            </div>\n            <div class="col-sm-2 col-md-2">\n                <button type="button" class="btn btn-primary" id="re-request">Re-request</button>\n            </div>\n            <div class="col-sm-2 col-md-2">\n                <button type="button" class="btn btn-primary" id="fill-form">Fill form</button>\n            </div>\n        </div>\n        ';
 if (!isEditMode) { 
__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="login">Login</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="login" placeholder="Login" required=""\n                       value="'+
((__t=( object.login ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="password">Password</label>\n            <div class="col-sm-5 col-md-5">\n                <input class="form-control" type="password" id="password" placeholder="Password" required="">\n                <input class="form-control" type="text" id="password-hidden" style="display: none">\n            </div>\n            <div class="col-sm-4 col-md-4">\n                <button type="button" class="btn btn-primary" id="generate-pass">'+
((__t=( generatePassButtonText ))==null?'':__t)+
'</button>\n            </div>\n        </div>\n        ';
 } 
__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="first-name">First Name</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="first-name" placeholder="First Name"\n                       value="'+
((__t=( object.firstName ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="middle-name">Middle Name</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="middle-name" placeholder="Middle Name"\n                       value="'+
((__t=( object.middleName ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="last-name">Last Name</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="last-name" placeholder="Last Name"\n                       value="'+
((__t=( object.lastName ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="birth-date">Birth Date</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="birth-date" placeholder="Birth Date"\n                       value="'+
((__t=( birthData ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="gender-values">Gender</label>\n            <div class="col-sm-9 col-md-9">\n                <select id="gender-values">\n                    <option value="M" ';
 if (object.gender == 'M') { 
__p+=' selected ';
 } 
__p+=' >Male</option>\n                    <option value="F" ';
 if (object.gender == 'F') { 
__p+=' selected ';
 } 
__p+=' >Female</option>\n                    <option value="NA" ';
 if (object.gender == 'NA') { 
__p+=' selected ';
 } 
__p+=' >NA</option>\n                </select>\n            </div>\n        </div>\n        ';
 if (!isEditMode) { 
__p+='\n        <div class="form-group">\n            <label class="col-xs-3 col-md-3 control-label">Address</label>\n            <div class="col-xs-3 col-md-3">\n                <input class="form-control address-field" type="text" id="town" placeholder="Town"/>\n            </div>\n            <div class="col-xs-4 col-md-4">\n                <div id="state-select"></div>\n            </div>\n            <div class="col-xs-2 col-md-2">\n                <input class="form-control address-field" type="text" id="zip" placeholder="Zip code"/>\n            </div>\n        </div>\n        <div class="form-group">\n            <div class="col-md-offset-3 col-xs-offset-3 col-xs-9 col-md-9">\n                <input class="form-control address-field" type="text" id="address" placeholder="Address line"/>\n            </div>\n        </div>\n        ';
 } 
__p+='\n\n        ';
 if (byAdmin || !isEditMode) { 
__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-md">Is Provider</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-md" style="margin-left: 10px;" ';
 if (object && object.isMd) { 
__p+='\n                checked ';
 } 
__p+=' >\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-patient">Is patient</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-patient" style="margin-left: 10px;" ';
 if (object &&
                object.isPatient) { 
__p+=' checked ';
 } 
__p+=' >\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-office-admin">Is Office Administrator</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-office-admin" style="margin-left: 10px;" ';
 if (object &&
                object.isOfficeAdministrator) { 
__p+=' checked ';
 } 
__p+=' >\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-medical-director">Is Medical Director</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-medical-director" style="margin-left: 10px;" ';
 if (object &&
                object.isMedicalDirector) { 
__p+=' checked ';
 } 
__p+=' >\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-manager">Is Manager</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-manager" style="margin-left: 10px;" ';
 if (object &&
                object.isManager) { 
__p+=' checked ';
 } 
__p+=' >\n            </div>\n        </div>\n        ';
 } 
__p+='\n        ';
 if (byAdmin) { 
__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="is-admin">Is Admin</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="is-admin" style="margin-left: 10px;" ';
 if (object && object.isAdmin) { 
__p+='\n                checked ';
 } 
__p+=' >\n            </div>\n        </div>\n        ';
 } 
__p+='\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="ssn">SSN</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="ssn" placeholder="SSN"\n                       value="'+
((__t=( object.ssn ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="insuranceId">Insurance ID</label>\n            <div class="col-sm-9 col-md-9">\n                <input class="form-control" type="text" id="insuranceId" placeholder="Insurance number"\n                       value="'+
((__t=( object.insuranceId ))==null?'':_.escape(__t))+
'">\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-sm-3 col-md-3 control-label" for="pending-docs-notif">Pending documents\n                notification</label>\n            <div class="checkbox col-sm-9 col-md-9">\n                <input type="checkbox" value="" id="pending-docs-notif" style="margin-left: 10px;" ';
 if (object &&
                object.pendingDocumentsNotification) { 
__p+=' checked ';
 } 
__p+=' >\n            </div>\n        </div>\n\n        <div class="form-group">\n            <label class="col-xs-3 col-md-3 control-label">Review period</label>\n            <label class="col-xs-1 col-md-1 control-label" for="review-period-days">Days</label>\n            <div class="col-xs-2 col-md-2">\n                <select id="review-period-days">\n                    ';
 _.each(days, function(day){ 
__p+='\n                    ';
 if (object.defaultReviewPeriod && object.defaultReviewPeriod.days && object.defaultReviewPeriod.days === day) { 
__p+='\n                    <option value="'+
((__t=( day ))==null?'':__t)+
'" name="'+
((__t=( day ))==null?'':__t)+
'" selected> '+
((__t=( day ))==null?'':__t)+
'</option>\n                    ';
 } else if (day === 3 && !object.defaultReviewPeriod) { 
__p+='\n                    <option value="'+
((__t=( day ))==null?'':__t)+
'" name="'+
((__t=( day ))==null?'':__t)+
'" selected> '+
((__t=( day ))==null?'':__t)+
'</option>\n                    ';
 } else { 
__p+='\n                    <option value="'+
((__t=( day ))==null?'':__t)+
'" name="'+
((__t=( day ))==null?'':__t)+
'"> '+
((__t=( day ))==null?'':__t)+
'</option>\n                    ';
 } 
__p+='\n                    ';
 }) 
__p+='\n                </select>\n            </div>\n            <label class="col-xs-1 col-md-1 control-label" for="review-period-hours">Hours</label>\n            <div class="col-xs-2 col-md-2">\n                <select id="review-period-hours">\n                    ';
 _.each(hours, function(hour){ 
__p+='\n                    ';
 if (object.defaultReviewPeriod && object.defaultReviewPeriod.hours && object.defaultReviewPeriod.hours === hour) { 
__p+='\n                    <option value="'+
((__t=( hour ))==null?'':__t)+
'" name="'+
((__t=( hour ))==null?'':__t)+
'" selected> '+
((__t=( hour ))==null?'':__t)+
'</option>\n                    ';
 } else if (hour === 0) { 
__p+='\n                    <option value="'+
((__t=( hour ))==null?'':__t)+
'" name="'+
((__t=( hour ))==null?'':__t)+
'" selected> '+
((__t=( hour ))==null?'':__t)+
'</option>\n                    ';
 } else { 
__p+='\n                    <option value="'+
((__t=( hour ))==null?'':__t)+
'" name="'+
((__t=( hour ))==null?'':__t)+
'"> '+
((__t=( hour ))==null?'':__t)+
'</option>\n                    ';
 } 
__p+='\n                    ';
 }) 
__p+='\n                </select>\n            </div>\n        </div>\n    </div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/person-form.html
// module id = 337
// module chunks = 0